import { useEffect, useState } from 'react';
import {
  Title,
  MainButton,
  MainLink,
  TextBold,
  TextRegular,
} from '../../styles/GlobalStyledComponents';
import { EndImage, EndText } from './EndStyledComponents';
import EndImg from '../../assets/images/end/endImage.svg';
import PostMessageService, {
  BannerOutcome,
} from '../../services/PostMessage';
import TokenService from '../../services/Token';
import { useCreditProposalResult } from '../../contexts/CreditProposalResultContext';
import { useProduct } from '../../contexts/ProductContext';
import { useCustomer } from '../../contexts/CustomerContext';
import { useLoanSimulation } from '../../contexts/LoanSimulationContext';
import ViewModeService from '../../services/ViewMode';
import CustomerDeviceService from '../../services/CustomerDevice';
import { useMerchant } from '../../contexts/MerchantContext';
import { useLocation, useSearchParams } from 'react-router-dom';
import FlowEndService from '../../services/FlowEndService';
import { CreditProposalResult } from '../../interfaces/CreditProposalResult';

interface EndProps {
  loadingEvent: (data: boolean) => void;
}

const HIGH_AMOUNT_THRESHOLD = 4000;

export const End: React.FC<EndProps> = ({ loadingEvent }) => {
  const location = useLocation();
  const { creditProposalResult, deleteCreditProposalResult } =
    useCreditProposalResult();
  const { deleteProduct } = useProduct();
  const { deleteCustomer } = useCustomer();
  const { deleteLoanSimulation } = useLoanSimulation();
  const { isApp } = useMerchant();
  const { isNemuru, isPostDataMessages } = useMerchant();
  const [device, setDevice] = useState<string | null>(null);
  const [customerDevice, setCustomerDevice] = useState<boolean>(false);

  const search = new URLSearchParams(location.search);
  const isChopApp = search?.get('is_app') === 'true';
  const [searchParams] = useSearchParams();
  const handleReturn = async () => {
    FlowEndService.clearPepperOneEnded();
    if (customerDevice && !isNemuru) {
      window.location.href = `https://clientes.pepperfinance.es/login/?utm_campaign=EndingPepperOne&utm_source=PepperOne&utm_medium=${ViewModeService.getViewMode() === "APP" || isChopApp ? "APP" : "WEB"
        }&utm_content=WEB`;
    } else {
      if (isApp && device === 'android') {
        window.location.href = 'peppermerchants://home';
      } else {
        PostMessageService.closeCEX();
      }
    }
  };

  const selectLowerText = () => {
    let lowerText;
    if (customerDevice && !isNemuru) {
      lowerText = (
        <>
          En la{' '}
          <TextBold $fontSize={14} $color="red6">
            App Pepper Clientes
          </TextBold>{' '}
          puedes consultar el estado y el detalle de tus financiaciones.
          ¡Descárgala en los principales stores!
        </>
      );
    } else {
      lowerText =
        'Ya hemos ordenado el abono de esta operación, recibirás todos los detalles por correo electrónico. Recuerda que al final del día recibirás un email con los detalles de liquidación de las operaciones tramitadas hoy.';
    }
    return lowerText;
  };

  useEffect(() => {
    setDevice(ViewModeService.getDevice());
    if (CustomerDeviceService.getCustomerDevice()) {
      setCustomerDevice(true);
    }
    if (isPostDataMessages && creditProposalResult) {
      PostMessageService.FinancingCompleted(
        creditProposalResult.credit_proposal_id
      );
    }
    if (creditProposalResult) {
      // Resultado para el banner del dashboard de Comercios.
      PostMessageService.BannerOutcome(
        BannerOutcome.ACTIVATED,
        {
          proposalId: creditProposalResult.credit_proposal_id,
          amount: creditProposalResult.loan_amount
        }
      );
      if (
        creditProposalResult.loan_amount > HIGH_AMOUNT_THRESHOLD ||
        creditProposalResult.customer?.require_enrichment_personal_finances
      ) {
        PostMessageService.BannerOutcome(
          BannerOutcome.BELENDER_OR_HIGH_AMOUNT,
          {
            proposalId: creditProposalResult.credit_proposal_id,
            amount: creditProposalResult.loan_amount
          }
        );
      }
      if (creditProposalResult.counter_offer_id) {
        PostMessageService.BannerOutcome(
          BannerOutcome.COUNTER_OFFER,
          {
            proposalId: creditProposalResult.credit_proposal_id,
            amount: creditProposalResult.loan_amount
          }
        );
      }
    }
    deleteCreditProposalResult();
    deleteProduct();
    deleteCustomer();
    deleteLoanSimulation();

    TokenService.clearSession();
    FlowEndService.setPepperOneEnded('END');
    loadingEvent(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Title id="end-title">¡Gracias!</Title>
      <EndText $fontSize={14} $align="center">
        {customerDevice ? (
          'Acabamos de mandarte un e-mail con toda la documentación de tu financiación.'
        ) : (
          <>
            Indícale a tu cliente que le hemos enviado un email con toda la
            documentación de su financiación. En la{' '}
            <TextBold $fontSize={14} $color="red6">
              App Pepper Clientes
            </TextBold>
            , disponible en los principales stores, puede consultar el detalle y
            estado de sus financiaciones.
          </>
        )}
      </EndText>
      <EndImage src={EndImg}></EndImage>
      <EndText $fontSize={14} $align="center">
        {selectLowerText()}
      </EndText>
      {!isNemuru ? (
        isApp && device === 'ios' ? (
          <MainLink href="peppermerchants://home">Cerrar</MainLink>
        ) : (
          <MainButton id="end-close-button" onClick={handleReturn}>
            {customerDevice ? 'Canal cliente' : 'Cerrar'}
          </MainButton>
        )
      ) : (
        <MainButton id="end-close-button" onClick={handleReturn}>
          Cerrar
        </MainButton>
      )}
    </>
  );
};
